export const DEFAULT_LANGUAGE = 'en'
export const FALLBACK_LANGUAGE = 'en' 